module.exports = __webpack_public_path__ + "static/media/close-button-activity.5564302b.svg";